const c = {
  name: "WorldMiddleEast",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M17.3,5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,3.8,17.3,4.3,17.3,5z"/>
		<path class="st0" d="M8,12.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C6.8,11.7,7.3,12.3,8,12.3z"/>
		<path class="st0" d="M12,12.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C10.8,11.7,11.3,12.3,12,12.3z"
			/>
		<path class="st0" d="M17.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,9.8,17.3,10.3,17.3,11z"
			/>
		<path class="st0" d="M20,12.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,11.7,19.3,12.3,20,12.3z"
			/>
		<path class="st0" d="M29.3,11c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,9.8,29.3,10.3,29.3,11z"
			/>
		<path class="st0" d="M32,12.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C30.8,11.7,31.3,12.3,32,12.3z"
			/>
		<path class="st0" d="M15.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C14.7,12.8,15.3,13.3,15.3,14z"
			/>
		<path class="st0" d="M18,15.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,14.7,17.3,15.3,18,15.3z"
			/>
		<path class="st0" d="M23.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,12.8,23.3,13.3,23.3,14z"
			/>
		<path class="st0" d="M26,15.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C24.8,14.7,25.3,15.3,26,15.3z"
			/>
		<path class="st0" d="M31.3,14c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C30.7,12.8,31.3,13.3,31.3,14z"
			/>
		<path class="st0" d="M34,15.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C32.8,14.7,33.3,15.3,34,15.3z"
			/>
		<path class="st0" d="M20,6.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,5.7,19.3,6.3,20,6.3z"/>
		<path class="st0" d="M25.3,5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C24.7,3.8,25.3,4.3,25.3,5z"/>
		<path class="st0" d="M10,9.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2C9.3,6.8,8.8,7.3,8.8,8C8.8,8.7,9.3,9.3,10,9.3z"/>
		<path class="st0" d="M15.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C14.7,6.8,15.3,7.3,15.3,8z"/>
		<path class="st0" d="M18,9.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,8.7,17.3,9.3,18,9.3z"/>
		<path class="st0" d="M23.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C22.7,6.8,23.3,7.3,23.3,8z"/>
		<path class="st0" d="M26,9.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C24.8,8.7,25.3,9.3,26,9.3z"/>
		<path class="st0" d="M31.3,8c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C30.7,6.8,31.3,7.3,31.3,8z"/>
		<path class="st0" d="M8,18.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C6.8,17.7,7.3,18.3,8,18.3z"/>
		<path class="st0" d="M21.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,15.8,21.3,16.3,21.3,17z"
			/>
		<path class="st0" d="M24,18.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.8,17.7,23.3,18.3,24,18.3z"
			/>
		<path class="st0" d="M29.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C28.7,15.8,29.3,16.3,29.3,17z"
			/>
		<path class="st0" d="M32,18.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C30.8,17.7,31.3,18.3,32,18.3z"
			/>
		<path class="st0" d="M37.3,17c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C36.7,15.8,37.3,16.3,37.3,17z"
			/>
		<path class="st0" d="M4,18.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C2.8,17.7,3.3,18.3,4,18.3z"/>
		<path class="st0" d="M11.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C10.7,18.8,11.3,19.3,11.3,20z"
			/>
		<path class="st0" d="M14,21.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C12.8,20.7,13.3,21.3,14,21.3z"
			/>
		<path class="st0" d="M19.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C18.7,18.8,19.3,19.3,19.3,20z"
			/>
		<path class="st0" d="M22,21.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C20.8,20.7,21.3,21.3,22,21.3z"
			/>
		<path class="st0" d="M27.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C26.7,18.8,27.3,19.3,27.3,20z"
			/>
		<path class="st0" d="M34,21.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C32.8,20.7,33.3,21.3,34,21.3z"
			/>
		<path class="st0" d="M7.3,20c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C6.7,18.8,7.3,19.3,7.3,20z"/>
		<path class="st0" d="M8,24.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C6.8,23.7,7.3,24.3,8,24.3z"/>
		<path class="st0" d="M13.3,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C12.7,21.8,13.3,22.3,13.3,23z"
			/>
		<path class="st0" d="M16,24.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C14.8,23.7,15.3,24.3,16,24.3z"
			/>
		<path class="st0" d="M21.3,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,21.8,21.3,22.3,21.3,23z"
			/>
		<path class="st0" d="M24,24.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C22.8,23.7,23.3,24.3,24,24.3z"
			/>
		<path class="st0" d="M37.3,23c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C36.7,21.8,37.3,22.3,37.3,23z"
			/>
		<path class="st0" d="M4,24.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C2.8,23.7,3.3,24.3,4,24.3z"/>
		<path class="st0" d="M11.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.3-0.6-1.3-1.2c0-0.7,0.6-1.2,1.3-1.2C10.7,24.8,11.3,25.3,11.3,26z"
			/>
		<path class="st0" d="M14,27.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C12.8,26.7,13.3,27.3,14,27.3z"
			/>
		<path class="st0" d="M19.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C18.7,24.8,19.3,25.3,19.3,26z"
			/>
		<path class="st0" d="M22,27.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C20.8,26.7,21.3,27.3,22,27.3z"
			/>
		<path class="st0" d="M7.3,26c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C6.7,24.8,7.3,25.3,7.3,26z"/>
		<path class="st0" d="M8,30.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C6.8,29.7,7.3,30.3,8,30.3z"/>
		<path class="st0" d="M13.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C12.7,27.8,13.3,28.3,13.3,29z"
			/>
		<path class="st0" d="M16,30.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C14.8,29.7,15.3,30.3,16,30.3z"
			/>
		<path class="st0" d="M21.3,29c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,27.8,21.3,28.3,21.3,29z"
			/>
		<path class="st0" d="M10,33.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.3,0.6-1.3,1.2C8.8,32.7,9.3,33.3,10,33.3z"/>
		<path class="st0" d="M15.3,32c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C14.7,30.8,15.3,31.3,15.3,32z"
			/>
		<path class="st0" d="M18,33.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C16.8,32.7,17.3,33.3,18,33.3z"
			/>
		<path class="st0" d="M17.3,35c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C16.7,33.8,17.3,34.3,17.3,35z"
			/>
		<path class="st0" d="M20,36.3c0.7,0,1.2-0.6,1.2-1.2c0-0.7-0.6-1.2-1.2-1.2c-0.7,0-1.2,0.6-1.2,1.2C18.8,35.7,19.3,36.3,20,36.3z"
			/>
		<path class="st0" d="M39.4,14.9c0.4,1.4,0.6,2.9,0.6,4.3v0c0,0.3,0,0.6,0,0.8s0,0.5,0,0.8c-0.3,7.8-5.2,14.8-12.4,17.7
			c-0.8,0.3-1.6,0.6-2.5,0.8c-0.7,0.2-1.3,0.3-1.9,0.4h-0.1c-0.5,0.1-1.1,0.2-1.8,0.2c-0.4,0-0.8,0-1.3,0c-0.4,0-0.9,0-1.3,0
			c-0.7-0.1-1.3-0.1-1.8-0.2h0c-0.6-0.1-1.3-0.2-1.9-0.4c-0.9-0.2-1.7-0.5-2.5-0.8C5.2,35.6,0.3,28.6,0,20.8c0-0.3,0-0.6,0-0.8
			c0-0.3,0-0.5,0-0.8c0.1-2.8,0.8-5.4,2-7.9l0-0.1c0.3-0.7,0.7-1.3,1.1-2c0.3-0.5,0.6-0.9,0.9-1.3c0.5-0.6,1-1.2,1.5-1.8
			c0.3-0.3,0.6-0.6,0.9-0.9c0.7-0.6,1.3-1.1,2-1.6c1.2-0.9,2.6-1.6,3.9-2.1c0.8-0.3,1.6-0.6,2.5-0.8c0.7-0.2,1.3-0.3,1.9-0.4h0.1
			c0.5-0.1,1.1-0.2,1.8-0.2C19.6,0,20.4,0,21.3,0c0.7,0,1.3,0.1,1.8,0.2h0c0.6,0.1,1.3,0.2,1.9,0.4c0.9,0.2,1.7,0.5,2.5,0.8
			c1.3,0.5,2.7,1.3,3.9,2.1c0.7,0.5,1.3,1,2,1.6c0.3,0.3,0.6,0.6,0.9,0.9c0.5,0.5,1.1,1.2,1.5,1.8c0.3,0.4,0.6,0.8,0.9,1.3
			c0.4,0.7,0.8,1.3,1.1,2l0.1,0.1c0.2,0.4,0.3,0.7,0.5,1.1C38.8,13.2,39.1,14.1,39.4,14.9z M24.6,37.4c0.8-0.2,1.5-0.5,2.2-0.8l0,0
			c6.4-2.6,10.7-8.6,11.2-15.4c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.5-1.2,1.2-1.2c-0.1-1.1-0.2-2.2-0.5-3.3c0-0.1,0-0.1-0.1-0.2
			s0-0.1-0.1-0.2c-0.3-0.2-0.5-0.6-0.5-1c0-0.1,0-0.3,0.1-0.4c0,0,0-0.1,0-0.1c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.3-0.3-0.7-0.5-1
			c0,0,0,0-0.1,0c0,0-0.1,0-0.2,0c-0.7,0-1.2-0.6-1.2-1.2c0-0.3,0.1-0.6,0.3-0.8c-0.2-0.3-0.4-0.7-0.7-1c-0.1,0-0.2,0.1-0.4,0.1
			c-0.7,0-1.2-0.6-1.2-1.2c0-0.2,0.1-0.4,0.1-0.5c-0.3-0.3-0.5-0.5-0.8-0.8c-0.3-0.2-0.5-0.5-0.8-0.7c-0.1-0.1-0.2-0.1-0.3-0.2
			c-0.2-0.2-0.5-0.4-0.8-0.6c-0.4-0.3-0.8-0.5-1.2-0.8c0.1,0.2,0.1,0.3,0.1,0.5c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2
			c0-0.6,0.5-1.1,1.1-1.2c-0.3-0.2-0.7-0.3-1-0.5c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.2,0.1-0.4,0.1c-0.4,0-0.8-0.2-1-0.5
			c-0.1,0-0.1,0-0.2-0.1s-0.1,0-0.2-0.1c-0.5-0.1-0.9-0.2-1.3-0.3l0,0c-0.1,0.5-0.6,1-1.2,1c-0.7,0-1.2-0.5-1.2-1.2
			c-0.5,0-1,0-1.5,0c0,0.7-0.6,1.2-1.2,1.2c-0.6,0-1.1-0.4-1.2-1c-0.5,0.1-0.9,0.2-1.4,0.3c-0.1,0-0.1,0-0.2,0.1s-0.1,0-0.2,0.1
			c-0.2,0.3-0.6,0.5-1,0.5c-0.1,0-0.3,0-0.4-0.1c0,0-0.1,0-0.1,0c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0.1-0.7,0.3-1,0.5
			c0.6,0.1,1.1,0.6,1.1,1.2c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.2,0-0.3,0.1-0.5C10.4,4.8,10,5,9.7,5.3
			C9.4,5.4,9.1,5.6,8.9,5.8C8.8,5.9,8.7,6,8.6,6.1C8.4,6.3,8.1,6.5,7.9,6.7C7.6,7,7.3,7.2,7.1,7.5C7.2,7.6,7.2,7.8,7.2,8
			c0,0.7-0.6,1.2-1.2,1.2c-0.1,0-0.3,0-0.4-0.1c-0.2,0.3-0.5,0.7-0.7,1c0.2,0.2,0.3,0.5,0.3,0.8c0,0.7-0.6,1.2-1.2,1.2
			c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c-1,2.1-1.6,4.3-1.7,6.5c0.7,0,1.2,0.6,1.2,1.2S2.7,21.2,2,21.2c0.4,5.9,3.7,11.3,8.8,14.3
			c-0.1-0.1-0.1-0.3-0.1-0.5c0-0.7,0.6-1.2,1.2-1.2c0.7,0,1.2,0.6,1.2,1.2c0,0.6-0.5,1.1-1.1,1.2c0.3,0.2,0.7,0.3,1,0.5
			c0.1,0,0.1,0,0.2,0.1s0.1,0,0.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.4,0,0.8,0.2,1,0.5c0.1,0,0.1,0,0.2,0.1s0.1,0,0.2,0.1
			c0.5,0.1,0.9,0.2,1.4,0.3c0.1-0.5,0.6-1,1.2-1c0.7,0,1.2,0.5,1.2,1.2c0.5,0,1,0,1.5,0c0-0.7,0.6-1.2,1.2-1.2c0.6,0,1.1,0.4,1.2,1
			C23.6,37.6,24.1,37.5,24.6,37.4z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as WorldMiddleEast
};
